import { Controller } from "@hotwired/stimulus"
import { post, destroy } from '../../helpers/request_helpers'

export default class extends Controller {
  static classes = ['buttons']

  static values = {
    url: String,
    userSignedIn: { type: Boolean, default: true }
  }

  async favorite() {
    if (!this.userSignedInValue) {
      this.dispatch('login-required')
      return
    }

    this.#disableButtons()

    try {
      await post(this.urlValue)
    } catch {
      this.#enableButtons()
    }
  }

  async unfavorite() {
    this.#disableButtons()

    try {
      await destroy(this.urlValue)
    } catch {
      this.#enableButtons()
      return
    }

    this.dispatch('unfavorite')
  }

  #disableButtons() {
    this.#buttons.forEach(v => v.disabled = true)
  }

  #enableButtons() {
    this.#buttons.forEach(v => v.disabled = false)
  }

  get #buttons() {
    return this.hasButtonsClass ? document.querySelectorAll(`.${ this.buttonsClass }`) : [this.element]
  }
}
